import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Link from 'app/common/components/link';
import { components } from '@glowforge/ui-common';

import ReferralMain from './main';

const { Button, Markdown } = components;

const ReferralStripeReturn = (props) => {
  const onPaymentRequest = () => {
    props.requestPayment(props.stripeID, props.path);
  };

  return (
    <div className='ReferralPaymentPage contentPage'>
      <ReferralMain {...props} />
      <Button
        onClick={onPaymentRequest}
        type='default'
        size='large'>
        {props.pageStrings['credit-removal-button-for-returning-users-rto']}
      </Button>
      <div className='content footer-info'>
        <Markdown className='paragraph' source={_.get(props.returningText, 'text')} />
        <Button
          onClick={props.navigateToStripe}
          type='text'>
          {_.get(props.returningText, 'title')}
        </Button>
        <Markdown className='paragraph' source={_.get(props.paypalLinkText, 'text')} />
        <Link to={`/referral-payment?state=${props.path}&paypal=true`} className='button text'>
          {_.get(props.paypalLinkText, 'title')}
        </Link>
      </div>
    </div>
  );
};

ReferralStripeReturn.propTypes = {
  requestPayment: PropTypes.func.isRequired,
  stripeID: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  navigateToStripe: PropTypes.func.isRequired,
  pageStrings: PropTypes.objectOf(PropTypes.string).isRequired,
  paypalLinkText: PropTypes.objectOf(PropTypes.string).isRequired,
  returningText: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default ReferralStripeReturn;



// WEBPACK FOOTER //
// ./app/components/support/referral/stripe-return.jsx